import { Option } from "@quantumcast/ui";
import { t } from "../../global/Localization/translation";

export const ORDER_BY: Option[] = [
  { label: t("files.order.by.title"), value: "title" },
  { label: t("files.order.by.uploadedAt"), value: "uploadedAt" },
];